import { Component, Input } from '@angular/core';
import { ICartesianSeries } from '@activia/dataviz';

@Component({
  selector: 'amp-time-series-widget',
  templateUrl: './time-series-widget.component.html',
  styleUrls: ['./time-series-widget.component.scss'],
})
export class TimeSeriesWidgetComponent {
  @Input() yAxisLabel: string;
  @Input() yAxisSoftMax: number;
  @Input() yAxisMax: number;
  @Input() yAxisTickInterval: number;

  /** Time series data or error message */
  @Input() data: Array<ICartesianSeries> | string;
  @Input() dataUnit: string;

  /** Label for average value if need to show the average value for this timeseries chart */
  @Input() averageLabel: string;

  @Input() precision: number;

  widgetHeight = 250;

  get hasError(): boolean {
    return typeof this.data === 'string';
  }

  get timezone(): string {
    return Intl.DateTimeFormat().resolvedOptions().timeZone;
  }

  trackByFn(_, serie: ICartesianSeries) {
    return serie.key;
  }
}
